<template>
  <div id="detail">
    <div class="detail-back" id="detail-back">
      <a href="" @click.prevent="showMaster" class="violet">Volver</a>
    </div>
    <Header :character="character"></Header>
    <div class="detail-body column ">
      <!-- Biografía -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">Biografía</h2>
        <div class="font-300 detail-body-text" v-html="character.bio"></div>
      </div>
      <!-- Otros cargos públicos -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">Otros cargos públicos</h2>
        <p class="font-300 detail-body-text" v-for="(job, index) in character.jobs" :key="index">{{ job }}</p>
      </div>
      <!-- ¿Cómo tiene distribuido los bienes patrimoniales el congresista y sus familiares? -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">¿Cómo tiene distribuido los bienes patrimoniales el congresista y sus familiares?</h2>
        <p class="font-300 detail-body-text">Haz clic sobre los números debajo de los íconos para obtener más información</p>
        <div class="assets">
          <template v-for="(asset, index) in character.assets">
            <div v-if="asset.qty" class="asset-box column h-centered" :key="index">
              <img :src="asset.icon"/>
              <p class="asset-qty scarlet" @click="emitModal(asset)">{{asset.qty}}</p>
              <p class="asset-label">{{asset.label}}</p>
            </div>
          </template>
        </div>
      </div>
      <!-- Declaración de renta -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">Declaración de renta</h2>
        <p class="font-300 detail-body-text line v-centered justify-between">
          <span>Tiene declaración pública</span>
          <span class="line v-centered">
            <span :class="['marker separated column v-centered h-centered', { filled: character.taxes.public }]">Sí</span>
            <span :class="['marker column v-centered h-centered', { filled: !character.taxes.public }]">No</span>
          </span>
        </p>
        <template v-if="character.taxes.public">
          <p class="font-300 detail-body-text">Años de declaración:
            <small v-for="(year, index) in character.taxes.years" :key="index">
              {{year}}{{index === character.taxes.years.length - 1 ? '.' : ', '}}
            </small>
          </p>
          <div v-for="(file, index) in character.taxes.file" :key="index" style="margin-bottom: 5px">
            <a :href="file" class="line v-centered download-anchor" target="blank">
              <img src="../../assets/media/download.svg" style="margin-right: 5px" />
              <small>Descargar</small>
            </a>
          </div>
        </template>
        <p v-if="character.taxes.register"><strong>Informes del año {{character.taxes.register}}</strong></p>
        <p class="font-300 detail-body-text line v-centered justify-between" v-if="character.taxes.patrimony">
          <span>Patrimonio libre de deudas:</span>
          <span>{{character.taxes.patrimony}}</span>
        </p>
        <p class="font-300 detail-body-text line v-centered justify-between" v-if="character.taxes.income">
          <span>Ingresos reportados:</span>
          <span>{{character.taxes.income}}</span>
        </p>
        <p class="font-300 detail-body-text line v-centered justify-between" v-if="character.taxes.pay">
          <span>Pago de impuestos:</span>
          <span>{{character.taxes.pay}}</span>
        </p>
        <p class="font-300 detail-body-text line v-centered justify-between" v-if="character.taxes.profit">
          <span>Rentas exentas<sup><small>*</small></sup>:</span>
          <span>{{character.taxes.profit}}</span>
        </p>
        <small v-if="character.taxes.disclaimer">{{character.taxes.disclaimer}}</small>
      </div>
      <!-- Registro de intereses privados -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">Registro de intereses privados</h2>
        <p class="font-300 detail-body-text line v-centered justify-between">
          <span>Tiene declaración pública</span>
          <span class="line">
            <span :class="['marker separated column centered', { filled: character.impediment.public }]">Sí</span>
            <span :class="['marker column centered', { filled: !character.impediment.public }]">No</span>
          </span>
        </p>
        <template v-if="character.impediment.public">
          <template v-for="info in character.impediment.info">
            <div v-for="(url, year, index) in info" :key="index">
              <a :href="url" class="line v-centered download-anchor" target="_blank">
                <img src="../../assets/media/download.svg" style="margin-right: 5px"/>
                <small style="margin-right: 5px">{{year}}</small>
                <small>Descargar</small>
              </a>
            </div>
          </template>
        </template>
        <p class="font-300 detail-body-text">{{character.impediment.description}}</p>
      </div>
      <!-- Intereses privados y legislación -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title line v-centered justify-between">
          <span>Intereses privados y legislación</span>
          <span class="line">
            <span :class="['marker separated column v-centered h-centered', { filled: character.legislate.done }]">Sí</span>
            <span :class="['marker column v-centered h-centered', { filled: !character.legislate.done }]">No</span>
          </span>
        </h2>
        <p class="detail-body-text" v-html="character.legislate.description"></p>
      </div>
      <!-- Respuesta al derecho de petición de Cuestión Pública y Dejusticia -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">Respuesta al derecho de petición de Cuestión Pública y Dejusticia</h2>
        <p>Cuestión Pública y Dejusticia le solicitó al congresista las declaraciones de renta del tiempo que lleva en el Congreso, vea la respuesta:</p>
        <p v-if="!character.response.deliver"><i>{{character.response.text}}</i></p>
        <template v-if="character.response.deliver">
          <template v-for="(pdf, index) in character.response.pdf">
            <a :href="pdf" class="line v-centered download-anchor" target="blank" :key="index">
              <img src="../../assets/media/download.svg" style="margin-right: 5px" />
              <small>Descargar</small>
            </a>
          </template>
        </template>
      </div>
      <!-- La red -->
      <div class="detail-body-section">
        <h2 class="violet detail-body-title">La red</h2>
        <p class="font-300 detail-body-text">El congresista y sus alianzas. Haz clic sobre los puntos para obtener mas información</p>
        <div class="line v-centered Wrap" style="margin-bottom: 5px">
          <template v-for="(value, key, index) in categories">
            <div class="line v-centered" style="margin-right: 10px" :key="index">
              <span class="bullet" :style="{ background: value }"></span>
              <small>{{key}}</small>
            </div>
          </template>
        </div>
        <Network :character="character" :network="network"></Network>
        <Footer />
        <div style="text-align: right">
          <a href="#detail" class="violet" style="text-decoration: none" data-scroll>Subir</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SweetScroll from 'sweet-scroll'
import Header from '@/components/detail/Header'
import Footer from '@/components/detail/Footer'
import Network from '@/components/detail/Network'

window.scroller = undefined

export default {
  props: ['character', 'network', 'categories'],
  components: { Header, Footer, Network },
  methods: {
    showMaster () {
      this.$emit('master')
    },
    emitModal (asset) {
      this.$emit('modal', asset)
    }
  },
  mounted () {
    window.scroller = new SweetScroll({})
  }
}
</script>

<style>
#detail {
  padding: 15px;
}
.detail-back {
  margin-bottom: 20px;
}
.detail-back a {
  text-decoration: none;
}
.detail-body-section {
  margin-bottom: 15px;
}
.detail-body-title {
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 10px;
}
.detail-body-text {
  font-size: 14px;
  line-height: 22px;
  margin: 0 0 5px;
}
.assets {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}
.asset-qty {
  cursor: pointer;
  font-size: 150%;
  margin: 2px 0;
}
.asset-label {
  margin: 0 0 2px;
}
.marker {
  border-radius: 50%;
  border: 1px solid #f52749;
  color: white;
  font-size: 12px;
  height: 20px;
  width: 20px;
}
.marker.filled {
  background: #f52749;
}
.marker.separated {
  margin-right: 5px;
}
.download-anchor {
  color: #f52749;
  margin-right: 5px;
  text-decoration: none;
}
.bullet {
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 5px;
  width: 10px;
}
@media only screen and (min-width: 768px) {
  .detail-body-title {
    font-size: 24px;
  }
  .detail-body-text {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/Detail.vue